




























































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import { Debounce } from '../../../jbi-shared/util/debounce.vue-decorator';
import {
  ResourceTypes,
  RoleExceptionFilter
} from '../../../store/modules/roles-and-permissions/types/roles-and-permissions.types';
import { RootState } from '../../../store/store';
import { ModuleTree } from '@/store/modules/module-tree/types/module-tree.types';
import CreateExceptionsModal from './CreateExceptionsModal.vue';
import AssignToRoleModal from './AssignToRoleModal.vue';

@Component({
  components: {}
})
export default class RoleExceptionFilterActionComponent extends Vue {
  private rolePlaceholder: string = 'All Roles';
  private showFilter = false;

  @Prop(Object) private selectedFilterOption!: RoleExceptionFilter;
  @Prop(String) private label!: string;
  @Prop(String) private placeholder!: string;
  @Prop(String) private resourceType!: ResourceTypes;

  @Action('moduleTree/getModuleTree')
  private getModuleTree!: () => Promise<ModuleTree[]>;

  @State(({ moduleTree }: RootState) => moduleTree.moduleTree)
  private moduleTree!: ModuleTree[];

  get activeFilterCount(): number {
    let count = 0;

    if (this.selectedFilterOption.search) count++;
    if (this.selectedFilterOption.role) count++;
    if (this.selectedFilterOption.exception) count++;

    return count;
  }

  mounted() {
    this.selectedFilterOption.exception = null;
    this.getModuleTree();
  }

  @Watch('selectedFilterOption', { deep: true })
  @Debounce(600)
  public onChange() {
    this.$emit('input', this.selectedFilterOption);
  }

  @Debounce(600)
  public resetFilter() {
    this.$emit('resetFilter');
  }

  toggleFilter() {
    this.showFilter = !this.showFilter;
  }

  private assignToRole(): void {
    this.$buefy.modal.open({
      parent: this,
      component: AssignToRoleModal,
      hasModalCard: true,
      trapFocus: true,
      props: {
        role: null,
        resourceType: this.resourceType
      },
      events: {
        roleUpdated: () => {
          this.resetFilter();
        }
      }
    });
  }

  private openCreateNewExceptionModal(): void {
    this.$buefy.modal.open({
      parent: this,
      component: CreateExceptionsModal,
      hasModalCard: true,
      trapFocus: true,
      fullScreen: true,
      props: {
        modalResourceType: this.resourceType
      },
      events: {
        refresh: () => {
          this.resetFilter();
        }
      }
    });
  }
}
